import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewRoarActivityReviewComponent } from '../../../../components/review-content/review-roar-activity-review/review-roar-activity-review.component';

@Component({
  selector: 'roar-review-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewRoarActivityReviewComponent
  ],
  templateUrl: './roar-review-submission.component.html',
  styleUrl: './roar-review-submission.component.css'
})
export class RoarReviewSubmissionComponent implements OnInit {

  @Input() roarAssignmentFormData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  currentRoarId: string | null = null;

  ngOnInit(): void {
    if (this.roarAssignmentFormData) {
      this.currentRoarId = this.roarAssignmentFormData.roar_id;
    }
  }

  submitRoarAssignment(): void {
    this.onSaveSection3.emit({});
  }

}
